import React from 'react';
import ImageGalleryladieswing from '../components/ImageGalleryladieswing';
// import IRCTVDonationCard from "./IRCTVDonationCard";

const IRCLADIES = () => {
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
           <button 
          onClick={() => window.history.back()}
          style={{
            marginBottom: '10px',
            padding: '8px 10px',
            backgroundColor: '#255fe8',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          ← Back to All Activities
        </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGalleryladieswing />

                    {/* IRC 10 Days Conference */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>LADIES WINGS</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                The Ladies’ wing of IRC conducts weekly lectures exclusively for women, by IRC certified male and female speakers, which are attended by hundreds of women. Alhamdulillaah, this wing has created a great deal of awareness among sisters.
                            </p>
                        </div>
                                    {/* <IRCTVDonationCard 
               title="LADIES WINGS"
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹5000"
              purpose="Cause: LADIES WINGS"
            /> */}
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCLADIES;
